/** An existing catalogue ID does not prove that the displayed changes have been saved. */
export const isDraftRevisionApplied = (draft: { revisionNumber?: number | null; appliedRevisionNumber?: number | null } | undefined) =>
    draft?.revisionNumber != null && draft.appliedRevisionNumber === draft.revisionNumber;
